// @ts-strict-ignore
import React from 'react';
import {
  Box, Button, ButtonSize, ButtonVariant,
} from '@usealloy/component-library';
import { exitLinkedChildActionThunk, saveLinkedChildActionThunk } from 'flow/store/redux/thunks';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectIsEditingLinkedChildAction, selectLinkedChildActionState, selectPreviewAction } from '~/dashboard/views/workflows/store/redux/selectors';

export default function LinkedChildActionFooter() {
  const dispatch = useAppDispatch();

  const previewActionBeingBuilt = useAppSelector(selectPreviewAction);
  const isEditingLinkedChildAction = useAppSelector(selectIsEditingLinkedChildAction);
  const linkedChildAction = useAppSelector(selectLinkedChildActionState);

  const isActionPayloadCreated = Boolean(linkedChildAction?.createActionPayload);

  const handleSecondaryClick = React.useCallback(() => {
    if (isEditingLinkedChildAction) {
      dispatch(exitLinkedChildActionThunk(previewActionBeingBuilt.publicId));
    }
  }, [dispatch, isEditingLinkedChildAction, previewActionBeingBuilt?.publicId]);

  const handlePrimaryClick = React.useCallback(() => {
    dispatch(saveLinkedChildActionThunk());
  }, [dispatch]);

  return (
    <Box
      style={{ height: '100%', padding: '0px var(--cl-space-6)' }}
      gap={2}
      alignItems="center"
      justifyContent="flex-end"
    >
      <Button
        data-dd-action-name="linked-child-action-cancel"
        onClick={handleSecondaryClick}
        size={ButtonSize.small}
        variant={ButtonVariant.secondary}
      >
        Cancel
      </Button>
      <Button
        data-dd-action-name="linked-child-action-save"
        disabled={!isActionPayloadCreated}
        onClick={handlePrimaryClick}
        size={ButtonSize.small}
        variant={ButtonVariant.primary}
      >
        Save
      </Button>
    </Box>

  );
}
